var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-container-content", attrs: { id: "boxInfo" } },
    [
      _c("div", { staticClass: "filter-container-title" }, [
        _vm.titleFlag == ""
          ? _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [_vm._v(_vm._s(_vm.$t("home.boxInfo")))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.titleFlag == "2"
          ? _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [_vm._v(_vm._s(_vm.$t("home.boxInfoPrevious")))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.titleFlag == "3"
          ? _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [_vm._v(_vm._s(_vm.$t("home.boxInfoCurrent")))]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "text",
                  disabled: _vm.preLockFlag || _vm.isDisable,
                },
                on: { click: _vm.handleImportVgm },
              },
              [_vm._v(_vm._s(_vm.$t("home.bookMySix")))]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: {
                  type: "text",
                  disabled: _vm.preLockFlag || _vm.isDisable,
                },
                on: { click: _vm.handleAvg },
              },
              [_vm._v(_vm._s(_vm.$t("home.evenlyDivide")))]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: {
                  type: "text",
                  disabled: _vm.preLockFlag || _vm.isDisable,
                },
                on: { click: _vm.handleSum },
              },
              [_vm._v(_vm._s(_vm.$t("home.countInfo")))]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: {
                  type: "text",
                  icon: "el-icon-plus",
                  disabled:
                    _vm.form.pol === "CNSHK" || _vm.form.pol.startsWith("TH"),
                },
                on: { click: _vm.handleAddVgmTitle },
              },
              [_vm._v(_vm._s(_vm.$t("home.vgmTitle")) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: {
                  type: "text",
                  icon: "el-icon-plus",
                  disabled: _vm.preLockFlag || _vm.isDisable,
                },
                on: { click: _vm.handleAddBox },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("home.boxInfo")) + "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-container-new-back" },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              attrs: { data: _vm.form.webBkContainerComs },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: _vm.$t("home.No"), width: "60" },
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { prop: "containerNo", "min-width": "170" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              class: _vm.tableClass(
                                "containerNo" + scope.$index
                              ),
                              attrs: {
                                prop:
                                  "webBkContainerComs." +
                                  scope.$index +
                                  ".containerNo",
                                rules: _vm.rules.containerNo,
                              },
                            },
                            [
                              _c("el-input", {
                                directives: [
                                  { name: "uppercase", rawName: "v-uppercase" },
                                  { name: "trim", rawName: "v-trim" },
                                  { name: "fth", rawName: "v-fth" },
                                ],
                                ref: "containerNo",
                                attrs: {
                                  maxlength: "50",
                                  onblur:
                                    "this.value = this.value.toUpperCase()",
                                  disabled: _vm.preLockFlag,
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.getContainerType(
                                      scope.row.containerNo,
                                      scope.$index
                                    )
                                  },
                                },
                                model: {
                                  value: scope.row.containerNo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      scope.row,
                                      "containerNo",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "scope.row.containerNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(" *"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(_vm._s(_vm.$t("home.containerNo"))),
                    ]),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { prop: "containerType", width: "130" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "webBkContainerComs." +
                                  scope.$index +
                                  ".containerType",
                                rules: _vm.rules.containerType,
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  class: _vm.tableClass(
                                    "containerType" + scope.$index
                                  ),
                                  attrs: { disabled: _vm.preLockFlag },
                                  model: {
                                    value: scope.row.containerType,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "containerType", $$v)
                                    },
                                    expression: "scope.row.containerType",
                                  },
                                },
                                _vm._l(
                                  _vm.containerTypeList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: item, value: item },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(" *"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(_vm._s(_vm.$t("home.containerType"))),
                    ]),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { prop: "sealNo1", "min-width": "170" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              class: _vm.tableClass("sealNo1" + scope.$index),
                              attrs: {
                                prop:
                                  "webBkContainerComs." +
                                  scope.$index +
                                  ".sealNo1",
                                rules: _vm.rules.sealNo1,
                              },
                            },
                            [
                              _c("el-input", {
                                directives: [
                                  { name: "uppercase", rawName: "v-uppercase" },
                                  { name: "trim", rawName: "v-trim" },
                                  { name: "fth", rawName: "v-fth" },
                                ],
                                attrs: {
                                  disabled:
                                    _vm.preLockFlag && _vm.form.pol === "CNDLC",
                                  maxlength: "50",
                                  onblur:
                                    "this.value = this.value.toUpperCase()",
                                },
                                model: {
                                  value: scope.row.sealNo1,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      scope.row,
                                      "sealNo1",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "scope.row.sealNo1",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(" *"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(_vm._s(_vm.$t("home.sealNo1"))),
                    ]),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "webBkContainerComs." +
                                  scope.$index +
                                  ".quantity",
                                rules: _vm.rules.quantity,
                              },
                            },
                            [
                              _c("el-input-number", {
                                class: _vm.tableClass(
                                  "quantity" + scope.$index
                                ),
                                attrs: {
                                  precision: 0,
                                  "auto-cut": true,
                                  controls: false,
                                  max: 9999999999,
                                  disabled: _vm.preLockFlag,
                                },
                                model: {
                                  value: scope.row.quantity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      scope.row,
                                      "quantity",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "scope.row.quantity",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(" *"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(_vm._s(_vm.$t("home.imoQuantity"))),
                    ]),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { width: "110" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "webBkContainerComs." +
                                  scope.$index +
                                  ".weight",
                                rules: _vm.rules.weight,
                              },
                            },
                            [
                              _c("el-input-number", {
                                class: _vm.tableClass("weight" + scope.$index),
                                attrs: {
                                  precision: 3,
                                  "auto-cut": true,
                                  controls: false,
                                  max: 999999999.999,
                                  disabled: _vm.preLockFlag,
                                },
                                model: {
                                  value: scope.row.weight,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      scope.row,
                                      "weight",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "scope.row.weight",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(" *"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(_vm._s(_vm.$t("home.overWeight"))),
                    ]),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { width: "120", prop: "cntrSize" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "webBkContainerComs." +
                                  scope.$index +
                                  ".cntrSize",
                                rules: _vm.rules.cntrSize,
                              },
                            },
                            [
                              _c("el-input-number", {
                                class: _vm.tableClass(
                                  "cntrSize" + scope.$index
                                ),
                                attrs: {
                                  precision: 3,
                                  "auto-cut": true,
                                  controls: false,
                                  max: 99999999999.999,
                                  disabled:
                                    _vm.preLockFlag &&
                                    _vm.form.pol &&
                                    _vm.form.pol === "CNDLC",
                                },
                                model: {
                                  value: scope.row.cntrSize,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      scope.row,
                                      "cntrSize",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "scope.row.cntrSize",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(" *"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(_vm._s(_vm.$t("home.cntrSize"))),
                    ]),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { width: "150", prop: "containerManager" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              class: _vm.tableClass(
                                "containerManager" + scope.$index
                              ),
                              attrs: {
                                prop:
                                  "webBkContainerComs." +
                                  scope.$index +
                                  ".containerManager",
                                rules: _vm.rules.containerManager,
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { disabled: _vm.preLockFlag },
                                  model: {
                                    value: scope.row.containerManager,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "containerManager",
                                        $$v
                                      )
                                    },
                                    expression: "scope.row.containerManager",
                                  },
                                },
                                _vm._l(
                                  _vm.containerManagerList,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.codeValue,
                                      attrs: {
                                        disabled:
                                          _vm.form.socCheckFlag === 1
                                            ? item.codeValue !== "SOC"
                                            : item.codeValue === "SOC",
                                        label:
                                          _vm.language === "zh"
                                            ? item.displayValueCn
                                            : item.displayValue,
                                        value: item.codeValue,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(" *"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(_vm._s(_vm.$t("home.containerManager"))),
                    ]),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { prop: "cargoTypeCode", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "webBkContainerComs." +
                                  scope.$index +
                                  ".cargoTypeCode",
                                rules: _vm.rules.cargoTypeCode,
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { disabled: _vm.preLockFlag },
                                  model: {
                                    value: scope.row.cargoTypeCode,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "cargoTypeCode", $$v)
                                    },
                                    expression: "scope.row.cargoTypeCode",
                                  },
                                },
                                _vm._l(_vm.cargoList, function (item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      label:
                                        _vm.language === "zh"
                                          ? item.nameCn
                                          : item.name,
                                      value: item.code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(" *"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "required-marker" }, [
                      _vm._v(_vm._s(_vm.$t("home.cargoTypeCode"))),
                    ]),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: {
                    "min-width": "110",
                    prop: "socReturn",
                    label: _vm.$t("home.socReture"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop:
                                  "webBkContainerComs." +
                                  scope.$index +
                                  ".socReturn",
                                rules: _vm.rules.socReturn,
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  class: _vm.tableClass(
                                    "socReturn" + scope.$index
                                  ),
                                  attrs: {
                                    clearable: "",
                                    disabled: _vm.preLockFlag,
                                  },
                                  model: {
                                    value: scope.row.socReturn,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "socReturn", $$v)
                                    },
                                    expression: "scope.row.socReturn",
                                  },
                                },
                                _vm._l(_vm.directionList, function (item) {
                                  return _c("el-option", {
                                    key: item.codeValue,
                                    attrs: {
                                      label:
                                        _vm.language === "zh"
                                          ? item.displayValueCn
                                          : item.displayValue,
                                      disabled: !_vm.form.webBkSocComs.some(
                                        function (it) {
                                          return (
                                            it.direction ===
                                            Number(item.codeValue)
                                          )
                                        }
                                      ),
                                      value: Number(item.codeValue),
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _vm.form.socCheckFlag
                    ? _c("template", { slot: "header" }, [
                        _c("span", { staticClass: "required-marker" }, [
                          _vm._v(" *"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "required-marker" }, [
                          _vm._v(_vm._s(_vm.$t("home.socReture"))),
                        ]),
                      ])
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  width: "120",
                  prop: "overForeward",
                  label: _vm.$t("home.overForeward"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            class: _vm.tableClass(
                              "overForeward" + scope.$index
                            ),
                          },
                          [
                            _c("el-input-number", {
                              attrs: {
                                precision: 3,
                                "auto-cut": true,
                                controls: false,
                                max: 9999999.999,
                                disabled: _vm.preLockFlag,
                              },
                              model: {
                                value: scope.row.overForeward,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "overForeward",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "scope.row.overForeward",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  width: "120",
                  prop: "overAftward",
                  label: _vm.$t("home.overAftward"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            class: _vm.tableClass("overAftward" + scope.$index),
                          },
                          [
                            _c("el-input-number", {
                              attrs: {
                                precision: 3,
                                "auto-cut": true,
                                controls: false,
                                max: 9999999.999,
                                disabled: _vm.preLockFlag,
                              },
                              model: {
                                value: scope.row.overAftward,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "overAftward",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "scope.row.overAftward",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  width: "140",
                  prop: "overLeft",
                  label: _vm.$t("home.overLeft"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          { class: _vm.tableClass("overLeft" + scope.$index) },
                          [
                            _c("el-input-number", {
                              attrs: {
                                precision: 3,
                                "auto-cut": true,
                                controls: false,
                                max: 9999999.999,
                                disabled: _vm.preLockFlag,
                              },
                              model: {
                                value: scope.row.overLeft,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "overLeft",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "scope.row.overLeft",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  prop: "overRight",
                  label: _vm.$t("home.overRight"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          { class: _vm.tableClass("overRight" + scope.$index) },
                          [
                            _c("el-input-number", {
                              attrs: {
                                precision: 3,
                                "auto-cut": true,
                                controls: false,
                                max: 9999999.999,
                                disabled: _vm.preLockFlag,
                              },
                              model: {
                                value: scope.row.overRight,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "overRight",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "scope.row.overRight",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  width: "120",
                  prop: "overHeight",
                  label: _vm.$t("home.overHeight"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            class: _vm.tableClass("overHeight" + scope.$index),
                          },
                          [
                            _c("el-input-number", {
                              attrs: {
                                precision: 3,
                                "auto-cut": true,
                                controls: false,
                                max: 9999999.999,
                                disabled: _vm.preLockFlag,
                              },
                              model: {
                                value: scope.row.overHeight,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "overHeight",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "scope.row.overHeight",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("i", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.disabled,
                              expression: "!disabled",
                            },
                          ],
                          staticClass: "el-icon-remove-outline",
                          attrs: { hidden: _vm.preLockFlag },
                          on: {
                            click: function ($event) {
                              return _vm.handleRemove(scope.row, scope.$index)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("template", { slot: "append" }, [
                _c("div", { staticClass: "sum-row" }, [
                  _c("div", { staticClass: "blank" }, [
                    _vm._v(_vm._s(_vm.$t("home.totalInfo"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "quantity" }, [
                    _vm._v(_vm._s(_vm.quantityCount)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "weight" }, [
                    _vm._v(_vm._s(_vm.weightCount)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "size" }, [
                    _vm._v(_vm._s(_vm.cntrSizeCount)),
                  ]),
                ]),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("vgMDialog", {
        ref: "vgMDialog",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          formMain: _vm.form,
          isDisable: this.isDisable,
          preLockFlag: _vm.preLockFlag,
          webBkContainerComs: _vm.form.webBkContainerComs,
          containerTypeList: _vm.containerTypeList,
          visible: _vm.vgMDialogDialogVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.vgMDialogDialogVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("vgmImportDialog", {
        ref: "vgmImportDialog",
        attrs: {
          "destroy-on-close": true,
          width: "40%",
          bookingId: _vm.bookingId,
          vgMDialogForm: _vm.vgMDialogForm,
          form: _vm.form,
          visible: _vm.vgmImportDialogVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.vgmImportDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }